import { config } from "../config";
import Call from "../utils/Call";
import storage from "../utils/Storage";

class Payment extends Call {
    constructor() {
        super(config.PAYMENT_API_HOST);
    }

    header() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.JWT_SECRET}`,
        };
    }

    async getCheckoutData(checkoutSessionId) {
        try {
            return await this.call("get", `/checkout/${checkoutSessionId}`, {});
        } catch (err) {
            return false;
        }
    }

    async createPaymentIntent(data) {
        try {
            return await this.call("post", `/create-payment-intent`, { data });
        } catch (err) {
            return false;
        }
    }

    async getPrices(event) {
        try {
            return await this.call("get", `/prices/${event}`, {});
        } catch (err) {
            return false;
        }
    }
}

export default new Payment();
